<div class="data-list-container">
  @if (config?.data) {
    <div class="data-list-wrapper">
      <table class="table table-hover data-list-table">
        <tbody>
          @for (row of config?.rows; track row; let even = $even; let i = $index) {
            <tr [ngClass]="{'even-row': even}">
              <th scope="row" class="data-list-header">{{row.label}}</th>
              <td class="data-list-value">
                @if (row.icon) {
                  <i [class]="row.icon(config?.data)"></i>
                } @else {
                  @if (!isEmpty(row.value(config?.data))) {
                    <span>{{row.value(config?.data)}}</span>
                  }
                  @if (isEmpty(row.value(config?.data))) {
                    <span class="text-muted">—</span>
                  }
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  @if (!config?.data) {
    <div class="data-list-empty">
      <div class="empty-state">
        <i class="fa fa-info-circle"></i>
        <p>No data available</p>
      </div>
    </div>
  }
</div>

